<template>
<div class="chapter">
<div class="inner_page">
<div id="Epub4211-7.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="PN-I" id="toc_marker-8"><span class="char-style-override-2">“ . . . Never tell all you feel, or (a better way still), feel very little . . .<br/>at any rate never have any feelings which may make you <br/>uncomfortable, or make any promises which you cannot at any </span><span class="char-style-override-2">required moment command and withdraw. That is the way to get on . . .”</span></p>
<p class="P-Epi-02 para-style-override-10">William Makepeace Thackeray: <span class="char-style-override-3">Vanity Fair</span></p>
<p class="P-Epi-02 para-style-override-10"><span class="char-style-override-11">1847</span></p>
<p class="P-Epi-02 para-style-override-8">“Wer spricht von Siegen? Überstehen ist Alles.”</p>
<p class="P-Epi-02 para-style-override-10">Rainer Maria Rilke: <span class="char-style-override-3">Requiem, für Wolf Graf von Kalckreuth</span></p>
<p class="P-Epi-02 para-style-override-10"><span class="char-style-override-11">1908</span></p>
<p class="P-Epi-02 para-style-override-8">“The warriors are dead. The warriors died in two world wars. <br/>Those who remain are the barterers. They know the price of <br/>coffee and cocoa and sugar and flour in a defeated country.”</p>
<p class="P-Epi-02 para-style-override-10">Kay Boyle: <span class="char-style-override-3">The Lovers of Gain</span></p>
<p class="P-Epi-02 para-style-override-10">1950</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epub42117.vue?0c8a84c3